export enum DistributionEnum {
  ORCHESTRA = 'ORCHESTRA',
  PULPO = 'PULPO',
  TRAVELEXCHANGE = 'TRAVELEXCHANGE',
}
